let live_questions = [
  [
    "thinking_feeling_15",
    "thinking",
    "feeling",
    "With which statement do you agree most",
    "مع أي جملة توافق بشكل أكثر؟",
    "Honest and direct",
    "صادق ومباشر",
    "Diplomatic",
    "دبلوماسي",
    "",
  ],
  [
    "thinking_feeling_14",
    "thinking",
    "feeling",
    "With which statement do you agree most",
    "مع أي جملة توافق بشكل أكثر؟",
    "Cool and reserved",
    "هادئ وكتوم",
    "Warm, friendly, emotional",
    "دافئ وودي وعاطفي",
    "",
  ],
  [
    "thinking_feeling_13",
    "thinking",
    "feeling",
    "With which statement do you agree most",
    "مع أي جملة توافق بشكل أكثر؟",
    "Search for truth, justice",
    "ابحث عن الحقيقة, العدل",
    "Aim for harmony, conformity",
    "اهدف إلى التوافق والإنسجام",
    "",
  ],
  [
    "extra_introversion_12",
    "extravert",
    "introvert",
    "With which statement do you agree most",
    "مع أي جملة توافق بشكل أكثر؟",
    "Do it first, think later",
    "افعل اولا, وافكر لاحقا",
    "Think first, do later",
    "افكر أولا, وافعل لاحقا",
    "",
  ],
  [
    "judging_perceiving_13",
    "judging",
    "perceiving",
    "With which statement do you agree most",
    "مع أي جملة توافق بشكل أكثر؟",
    "Know where you stand",
    "اعرف المكان الذي تقف فيه",
    "Discover as it goes",
    "اكتشف بينما أسير",
    "",
  ],
  [
    "extra_introversion_11",
    "extravert",
    "introvert",
    "With which statement do you agree most",
    "مع أي جملة توافق بشكل أكثر؟",
    "Easily distracted",
    "يسهل صرف انتباهي",
    "Concentrate well",
    "اركز جيدا",
    "",
  ],
  [
    "thinking_feeling_12",
    "thinking",
    "feeling",
    "With which statement do you agree most",
    "مع أي جملة توافق بشكل أكثر؟",
    "Objective criteria",
    "معايير موضوعية",
    "Subjective criteria",
    "معايير ذاتية",
    "",
  ],
  [
    "sensing_intuition_11",
    "sensing",
    "intuition",
    "With which statement do you agree most",
    "مع أي جملة توافق بشكل أكثر؟",
    "Ask questions like who, what, when and where?",
    "اسأل أسئلة مثل من وماذا ومتى وأين؟",
    "Ask questions like why?",
    "أطرح أسئلة مثل لماذا؟",
    "",
  ],
  [
    "judging_perceiving_12",
    "judging",
    "perceiving",
    "With which statement do you agree most",
    "مع أي جملة توافق بشكل أكثر؟",
    "You're in charge of your life",
    "أنت مسؤول عن حياتك",
    "Life happens along the way",
    "الحياة تأتي هكذا",
    "",
  ],
  [
    "extra_introversion_10",
    "extravert",
    "introvert",
    "With which statement do you agree most",
    "مع أي جملة توافق بشكل أكثر؟",
    "Think aloud",
    "افكر بصوت عال",
    "Think in silence",
    "افكر في صمت",
    "",
  ],
  [
    "thinking_feeling_11",
    "thinking",
    "feeling",
    "With which statement do you agree most",
    "مع أي جملة توافق بشكل أكثر؟",
    "Cause and effect",
    "السبب والتأثير",
    "Environment and consideration",
    "البيئة واعتباراتها",
    "",
  ],
  [
    "judging_perceiving_11",
    "judging",
    "perceiving",
    "With which statement do you agree most",
    "مع أي جملة توافق بشكل أكثر؟",
    "Plan ahead. Complete on time",
    "اخطط مسبقا. انهي في الوقت المحدد",
    "Postpone, take more time if necessary",
    "أقوم بالتأجيل, وأخذ المزيد من الوقت إن أمكن",
    "",
  ],
  [
    "extra_introversion_9",
    "extravert",
    "introvert",
    "With which statement do you agree most",
    "مع أي جملة توافق بشكل أكثر؟",
    "Keep on trying, everytime ",
    "استمر في المحاولة, في كل مرة",
    "Consider first before I take action",
    "أفكر مليا قبل اتخاذ القرار",
    "",
  ],
  [
    "thinking_feeling_10",
    "thinking",
    "feeling",
    "With which statement do you agree most",
    "مع أي جملة توافق بشكل أكثر؟",
    "Skeptical",
    "مرتاب",
    "Trusting",
    "واثق",
    "",
  ],
  [
    "sensing_intuition_10",
    "sensing",
    "intuition",
    "With which statement do you agree most",
    "مع أي جملة توافق بشكل أكثر؟",
    "Literal interpretation",
    "ترجمة حرفية",
    "Underlying thought",
    "الفكرة الأساسية",
    "",
  ],
  [
    "locus_10",
    "control",
    "faith",
    "With which statement do you agree most",
    "مع أي جملة توافق بشكل أكثر؟",
    "When I make plans, I am almost certain that I can make them work.",
    "عندما أقوم بوضع الخطط ، أكون على يقين بأنني أستطيع أن أجعلها تنجح.",
    "It is not always wise to plan too far ahead because many things turn out to be a matter of luck anyway.",
    ".ليس من الحكمة دائما التخطيط على المدى البعيد لأن العديد من الأشياء تصبح تعتمد على الحظ على أي حال.",
    "",
  ],
  [
    "judging_perceiving_10",
    "judging",
    "perceiving",
    "With which statement do you agree most",
    "مع أي جملة توافق بشكل أكثر؟",
    "One thing / project at a time",
    "القيام بشيء واحد / مشروع واحد على حدى",
    "Many things / projects simultaneously",
    "القيان بالكثير من الأشياء/المشاريع في وقت واحد",
    "",
  ],
  [
    "extra_introversion_8",
    "extravert",
    "introvert",
    "With which statement do you agree most",
    "مع أي جملة توافق بشكل أكثر؟",
    "Want to participate",
    "أريد المشاركة",
    "Want space and time for myself",
    "أريد مساحة ووقتا لنفسي",
    "",
  ],
  [
    "thinking_feeling_9",
    "thinking",
    "feeling",
    "With which statement do you agree most",
    "مع أي جملة توافق بشكل أكثر؟",
    "Appeciate logical reasoning",
    "ادعم التقدير المنطقي",
    "Appreciate reasoning based on feelings",
    "ادعم المنطق المبني على أساس المشاعر",
    "",
  ],
  [
    "sensing_intuition_9",
    "sensing",
    "intuition",
    "With which statement do you agree most",
    "مع أي جملة توافق بشكل أكثر؟",
    "More focused on the present",
    "أكثر تركيزا على الوقت الحاضر",
    "More focused on the future",
    "أكثر تركيزا على المستقبل",
    "",
  ],
  [
    "locus_9",
    "control",
    "faith",
    "With which statement do you agree most",
    "مع أي جملة توافق بشكل أكثر؟",
    "What happens to me is my own doing.",
    "كل ما يحدث لي هو نتيجة ما أفعل.",
    "Sometimes I feel that I don't have enough control over the direction my life is taking.",
    "أشعر أحيانًا بأنني لا أملك السيطرة الكافية على المنحى الذي تتخذه حياتي.",
    "",
  ],
  [
    "judging_perceiving_9",
    "judging",
    "perceiving",
    "With which statement do you agree most",
    "مع أي جملة توافق بشكل أكثر؟",
    "Orderly, predictable",
    "أنا منظم ، يمكن التنبؤ بي",
    "Spontaneous",
    "عفوي",
    "",
  ],
  [
    "extra_introversion_7",
    "extravert",
    "introvert",
    "With which statement do you agree most",
    "مع أي جملة توافق بشكل أكثر؟",
    "I like to have a lot of friends",
    "لدي الكثير من الأصدقاء",
    "I'd prefer a few close friends",
    "أفضل امتلاك أصدقاء معدودين",
    "",
  ],
  [
    "thinking_feeling_8",
    "thinking",
    "feeling",
    "With which statement do you agree most",
    "مع أي جملة توافق بشكل أكثر؟",
    "Consider what is fair and just",
    "فكر بما هو صحيح وفقط",
    "Consider human values and motives",
    "افكر في القيم والدوافع البشرية",
    "",
  ],
  [
    "sensing_intuition_8",
    "sensing",
    "intuition",
    "With which statement do you agree most",
    "مع أي جملة توافق بشكل أكثر؟",
    "See what is there, trust my experience",
    "ألاحظ كل شيء موجود وأثق بخبرتي",
    "See what it can be, trust my ideas",
    "أرى ما يمكن أن يكون ، اثق أفكاري",
    "",
  ],
  [
    "locus_8",
    "control",
    "faith",
    "With which statement do you agree most",
    "مع أي جملة توافق بشكل أكثر؟",
    "The idea that teachers are unfair to students is nonsense.",
    "فكرة أن المعلمين لا يعاملون الطلاب بشكل عادل هي كلام فارغ.",
    "Most students don't realize the extent to which their grades are influenced by accidental happenings.",
    "لا يدرك معظم الطلاب مدى تأثر درجاتهم بالصدف.",
    "",
  ],
  [
    "judging_perceiving_8",
    "judging",
    "perceiving",
    "With which statement do you agree most",
    "مع أي جملة توافق بشكل أكثر؟",
    "Check and arrange",
    "اتحقق وانظم",
    "Customize and change",
    "اعدل وارتب",
    "",
  ],
  [
    "extra_introversion_6",
    "extravert",
    "introvert",
    "With which statement do you agree most",
    "مع أي جملة توافق بشكل أكثر؟",
    "Interaction",
    "التفاعل ",
    "Reflection",
    "الارتكاس",
    "",
  ],
  [
    "thinking_feeling_7",
    "thinking",
    "feeling",
    "With which statement do you agree most",
    "مع أي جملة توافق بشكل أكثر؟",
    "Do what is right",
    "القيام بما هو صحيح",
    "Do what other want me to do",
    "افعل ما يريدني الآخرون أن أفعله",
    "",
  ],
  [
    "sensing_intuition_7",
    "sensing",
    "intuition",
    "With which statement do you agree most",
    "مع أي جملة توافق بشكل أكثر؟",
    "Details, specificities",
    "التفاصيل والخصائص",
    "The overview, the bigger picture",
    "النظرة الشاملة، الصورة الأكبر",
    "",
  ],
  [
    "locus_7",
    "control",
    "faith",
    "With which statement do you agree most",
    "مع أي جملة توافق بشكل أكثر؟",
    "The average citizen can have an influence in government decisions.",
    "يمكن أن يكون للمواطن العادي تأثير في قرارات الحكومة.",
    "This world is run by the few people in power, and there is not much the little guy can do about it.",
    "هذا العالم يتحكم به قلة قليلة, ولا يمكن لشخص ضعيف أن يفعل شيئا حيال ذلك ",
    "",
  ],
  [
    "judging_perceiving_7",
    "judging",
    "perceiving",
    "With which statement do you agree most",
    "مع أي جملة توافق بشكل أكثر؟",
    "Decisive",
    "حاسم",
    "Non judgmental",
    "غير حاسم",
    "",
  ],
  [
    "extra_introversion_5",
    "extravert",
    "introvert",
    "With which statement do you agree most",
    "مع أي جملة توافق بشكل أكثر؟",
    "Listen to what someone says",
    "أستمع إلى ما يقوله الشخص",
    "Listen to what people omit to say",
    "استمع إلى ما لا يقوله الناس",
    "",
  ],
  [
    "value_6",
    "now",
    "later",
    "What if your family was offered one of the following choices",
    "ماذا إذا أعطيت عائلتك أحد الخيارات الآتية",
    "Receive 100 USD today",
    "الحصول على 100 دولار اليوم",
    "Receive 120 USD next month",
    "الحصول على 120 دولار الشهر القادم",
    "",
  ],
  [
    "thinking_feeling_6",
    "thinking",
    "feeling",
    "With which statement do you agree most",
    "مع أي جملة توافق بشكل أكثر؟",
    "I want to perform",
    "أريد أن أعمل",
    "I want to be appreciated",
    "اريد ان يتم تقديري",
    "",
  ],
  [
    "sensing_intuition_6",
    "sensing",
    "intuition",
    "With which statement do you agree most",
    "مع أي جملة توافق بشكل أكثر؟",
    "Continuity and tradition",
    "الإستمرارية والتقليد",
    "New, improved ways to do something",
    "طرق جديدة ومحسنة لفعل شيء ما",
    "",
  ],
  [
    "locus_6",
    "control",
    "faith",
    "With which statement do you agree most",
    "مع أي جملة توافق بشكل أكثر؟",
    "One of the major reasons why we have wars is because people don't take enough interest in politics.",
    "أحد الأسباب الرئيسية لوجود الحروب هو أن الناس لا يهتمون بالسياسة.",
    "There will always be wars, no matter how hard people try to prevent them.",
    "ستكون دائما هناك حروب مهما حاول البشر ايقاف ذلك",
    "",
  ],
  [
    "judging_perceiving_6",
    "judging",
    "perceiving",
    "With which statement do you agree most",
    "مع أي جملة توافق بشكل أكثر؟",
    "I like making decisions and plans",
    "أنا أحب اتخاذ القرارات وعمل الخطط",
    "I like to keep it casual and spontaneous",
    "أحب أن اترك الأمور تسير بعفوية",
    "",
  ],
  [
    "extra_introversion_4",
    "extravert",
    "introvert",
    "With which statement do you agree most",
    "مع أي جملة توافق بشكل أكثر؟",
    "I like to talk",
    "أحب الكلام",
    "I like to think",
    "أحب التفكير",
    "",
  ],
  [
    "value_5",
    "now",
    "later",
    "What if your family was offered one of the following choices",
    "ماذا إذا أعطيت عائلتك أحد الخيارات الآتية",
    "Receive 100 USD today",
    "الحصول على 100 دولار اليوم",
    "Receive 50 USD next month",
    "الحصول على 50 دولار الشهر القادم",
    "",
  ],
  [
    "thinking_feeling_5",
    "thinking",
    "feeling",
    "",
    "",
    "Look at what the law is",
    "انظر إلى القانون",
    "Look at the situation",
    "انظر الى الوضع",
    "",
  ],
  [
    "sensing_intuition_5",
    "sensing",
    "intuition",
    "With which statement do you agree most",
    "مع أي جملة توافق بشكل أكثر؟",
    "Proud of what I can make (practical)",
    "فخور بما أستطيع فعله (عملي)",
    "Proud of ability to come up with solutions",
    "فخور بالقدرة على الخروج بالحلول",
    "",
  ],
  [
    "locus_5",
    "faith",
    "control",
    "With which statement do you agree most",
    "مع أي جملة توافق بشكل أكثر؟",
    "No matter how hard you try, some people just don't like you.",
    "مهما تحاول في بعض الأحيان، بعض الناس لا يحبونك.",
    "People who can't get others to like them don't understand how to get along with others.",
    "الأشخاص الذين يفشلون في جعل الآخرين يحبونهم, هم أشخاص لا يفهمون كيفية التعامل من الآخرين",
    "",
  ],
  [
    "judging_perceiving_5",
    "judging",
    "perceiving",
    "With which statement do you agree most",
    "مع أي جملة توافق بشكل أكثر؟",
    "Love to finish a project",
    "أحب الانتهاء من المشروع",
    "Love to start a project",
    "أحب أن أبدأ مشروع",
    "",
  ],
  [
    "extra_introversion_3",
    "extravert",
    "introvert",
    "With which statement do you agree most",
    "مع أي جملة توافق بشكل أكثر؟",
    "Enjoy group discussions",
    "استمتع بالنقاشات الجماعية",
    "Prefer one-on-one discussion",
    "أفضل النقاشات الفردية",
    "",
  ],
  [
    "value_4",
    "now",
    "later",
    "What if your family was offered one of the following choices",
    "ماذا إذا أعطيت عائلتك أحد الخيارات الآتية",
    "Receive 100 USD today",
    "الحصول على 100 دولار اليوم",
    "Receive 200 USD next week",
    "الحصول على 200 دولار الأسبوع القادم",
    "",
  ],
  [
    "thinking_feeling_4",
    "thinking",
    "feeling",
    "With which statement do you agree most",
    "مع أي جملة توافق بشكل أكثر؟",
    "Thoughtful",
    "مفكر ",
    "Sensitive",
    "حساس",
    "",
  ],
  [
    "sensing_intuition_4",
    "sensing",
    "intuition",
    "With which statement do you agree most",
    "مع أي جملة توافق بشكل أكثر؟",
    "In making decisions I rather trust the facts",
    "أثق بالحقائق",
    "In making decisions I rather trust my gut-feeling",
    "أثق بحدسي",
    "",
  ],
  [
    "locus_4",
    "faith",
    "control",
    "With which statement do you agree most",
    "مع أي جملة توافق بشكل أكثر؟",
    "Many of the unhappy things in people's lives are partly due to bad luck.",
    "الكثير من الأمور غير السعيدة في حياة الناس تعود جزئياً إلى الحظ السيئ.",
    "People's misfortunes result from the mistakes they make.",
    "مصائب الناس نتيجة للأخطاء التي يرتكبونها.",
    "",
  ],
  [
    "judging_perceiving_4",
    "judging",
    "perceiving",
    "With which statement do you agree most",
    "مع أي جملة توافق بشكل أكثر؟",
    "Work first, play later",
    "اعمل أولاً ، العب لاحقًا",
    "Play first, work later",
    "العب أولا, اعمل لاحقا",
    "",
  ],
  [
    "value_3",
    "now",
    "later",
    "What if your family was offered one of the following choices",
    "ماذا إذا أعطيت عائلتك أحد الخيارات الآتية",
    "Receive 100 USD today",
    "الحصول على 100 دولار اليوم",
    "Receive 150 USD in 6 months time",
    "الحصول على 150 دولار بعد 6 أشهر",
    "",
  ],
  [
    "thinking_feeling_3",
    "thinking",
    "feeling",
    "",
    "",
    "Systematic conclusions",
    "استنتاجات منهجية",
    "Emotional beliefs",
    "معتقدات العاطفية",
    "",
  ],
  [
    "sensing_intuition_3",
    "sensing",
    "intuition",
    "With which statement do you agree most",
    "مع أي جملة توافق بشكل أكثر؟",
    "Common sense",
    "الفطرة السليمة",
    "Creativity",
    "الإبداع",
    "",
  ],
  [
    "locus_3",
    "control",
    "faith",
    "With which statement do you agree most",
    "مع أي جملة توافق بشكل أكثر؟",
    "In the long run, people get the respect they deserve in this world.",
    "على المدى الطويل، يحظى الناس بالاحترام الذي يستحقونه في هذا العالم.",
    "Unfortunately, an individual's worth often passes unrecognized no matter how hard he tries.",
    "للأسف, فإن قيمة الفرد تمر في كثير من يتم إنكارها بغض النظر عن مدى صعوبة محاولته.\n",
    "",
  ],
  [
    "judging_perceiving_3",
    "judging",
    "perceiving",
    "With which statement do you agree most",
    "مع أي جملة توافق بشكل أكثر؟",
    "Make plans for this weekend.",
    "اضع خططًا لنهاية هذا الأسبوع.",
    "Leave the options for the weekend open.",
    "اترك خيارات نهاية الأسبوع مفتوحا",
    "",
  ],
  [
    "extra_introversion_2",
    "extravert",
    "introvert",
    "With which statement do you agree most",
    "مع أي جملة توافق بشكل أكثر؟",
    "Motivated by people / things",
    "يحفزني الناس/ الأشياء",
    "Motivated by ideas / fantasies",
    "تحفزني الأفكار/ الخيالات ",
    "",
  ],
  [
    "control_2",
    "correct",
    "incorrect",
    "Please press 'disagree' to answer this question.",
    'يرجى الضغط على "لا أوافق" للإجابة على هذا السؤال',
    "Agree",
    "أوافق",
    "Disagree",
    "لا أوفق",
    "",
  ],
  [
    "value_2",
    "now",
    "later",
    "What if your family was offered one of the following choices",
    "ماذا إذا أعطيت عائلتك أحد الخيارات الآتية",
    "Receive 100 USD today",
    "الحصول على 100 دولار اليوم",
    "Receive 200 USD next year",
    "الحصول على 200 دولار السنة القادمة",
    "",
  ],
  [
    "thinking_feeling_2",
    "thinking",
    "feeling",
    "With which statement do you agree most",
    "مع أي جملة توافق بشكل أكثر؟",
    "Justice and honesty",
    "العدل والصدق",
    "Compassion and mercy",
    "التعاطف والرحمة",
    "",
  ],
  [
    "sensing_intuition_2",
    "sensing",
    "intuition",
    "With which statement do you agree most",
    "مع أي جملة توافق بشكل أكثر؟",
    "Categorize, register",
    "التصنيف والتسجيل",
    "Understand, interpret",
    "الفهم والتفسير",
    "",
  ],
  [
    "locus_2",
    "control",
    "faith",
    "With which statement do you agree most",
    "مع أي جملة توافق بشكل أكثر؟",
    "I have often found that what is going to happen will happen.",
    "لقد وجدت في كثير من الأحيان, أن ما هو مقدر للحدوث سيحدث لا محالة",
    "Trusting to fate has never turned out as well for me as making a decision to take a definite course of action.",
    "لم يكن الإعتماد على القدر مفيدا بقدر اتخاذي للقرارات والمباشرة بتنفيذها",
    "",
  ],
  [
    "judging_perceiving_2",
    "judging",
    "perceiving",
    "With which statement do you agree most",
    "مع أي جملة توافق بشكل أكثر؟",
    "Time conscious",
    "مدرك للوقت",
    "Without time limit",
    "بدون حدود للوقت",
    "",
  ],
  [
    "extra_introversion_1",
    "extravert",
    "introvert",
    "With which statement do you agree most",
    "مع أي جملة توافق بشكل أكثر؟",
    "Get more energy by interacting",
    "احصل على مزيد من الطاقة من خلال التفاعل ",
    "Get more energy alone",
    "احصل على مزيد من الطاقة من خلال البقاء وحيدا",
    "",
  ],
  [
    "control_1",
    "correct",
    "incorrect",
    "With which statement do you agree most",
    "مع أي جملة توافق بشكل أكثر؟",
    "Blue is a color",
    "الأزرق عبارة عن لون",
    "Please select the other answer",
    "من فضلك اختر إجابة",
    "",
  ],
  [
    "value_1",
    "now",
    "later",
    "What if your family was offered one of the following choices",
    "ماذا إذا أعطيت عائلتك أحد الخيارات الآتية",
    "Receive 100 USD today",
    "الحصول على 100 دولار اليوم",
    "Receive 200 USD next week",
    "الحصول على 200 دولار الأسبوع القادم",
    "",
  ],
  [
    "thinking_feeling_1",
    "thinking",
    "feeling",
    "With which statement do you agree most",
    "مع أي جملة توافق بشكل أكثر؟",
    "Analytical, logical",
    "تحليلي ومنطقي",
    "Empathy, sympathetic",
    "الشفقة, التعاطف",
    "",
  ],
  [
    "sensing_intuition_1",
    "sensing",
    "intuition",
    "With which statement do you agree most",
    "مع أي جملة توافق بشكل أكثر؟",
    "Practical, down-to-earth",
    "عملي, متواضع",
    "Possibilities, implications",
    "الاحتمالات ، الآثار",
    "",
  ],
  [
    "locus_1",
    "control",
    "faith",
    "With which statement do you agree most",
    "مع أي جملة توافق بشكل أكثر؟",
    "Success is a matter of hard work, luck has little to do with it.",
    "النجاح هو عبارة عن عمل شاق, ولا علاقة للحظ بذلك",
    "Succeeding in business depends mainly on being in the right place at the right time.",
    " يعتمد النجاح في العمل بشكل رئيسي على أن تكون في المكان المناسب وفي الوقت المناسب.",
    "",
  ],
  [
    "judging_perceiving_1",
    "judging",
    "perceiving",
    "With which statement do you agree most",
    "مع أي جملة توافق بشكل أكثر؟",
    "Seriously and formally",
    " جدي ورسمي",
    "Playful and nonchalant",
    "مرح وغير مبالي",
    "",
  ],
];

export function add_choice_questions(assessment, test = true) {
  // export correct json
  (test ? live_questions.splice(1, 3) : live_questions).forEach((question) => {
    assessment.pages.push({
      name: question[0],
      elements: [
        {
          title: { en: question[3], ar: question[4] },
          name: question[0],
          type: "radiogroup",
          renderAs: "choice",
          isRequired: true,
          colCount: 0,
          otherText: { en: "I don't understand the question.", ar: "السؤال" },
          otherErrorText: {
            en: "Please describe briefly what it is you are unsure about.",
            ar: "يرجى تقديم وصف موجز لما هو غير متأكد.",
          },
          choices: [
            { value: question[1], text: { en: question[5], ar: question[6] } },
            { value: question[2], text: { en: question[7], ar: question[8] } },
          ],
        },
      ],
    });
  });
}
